module.exports = __webpack_public_path__ + "img/pomodoro-details2.ccfc71a3.png";